// Shared button style constants
import { MantineTheme } from "@mantine/core";

// Theme color tokens
export const getThemePrimaryDark = (theme: MantineTheme): string =>
  theme.colors["jem-theme"][5];

// Theme typography tokens
export const THEME_FONTS = {
  heading: "Manrope",
} as const;

/**
 * Returns History button styles using theme tokens
 * @param theme - Mantine theme object
 */
export const getHistoryButtonStyles = (
  theme: MantineTheme
): {
  root: Record<string, string>;
  label: Record<string, string | number>;
} => {
  const primaryDark = getThemePrimaryDark(theme);

  return {
    root: {
      border: `1px solid ${primaryDark}`,
      color: primaryDark,
      borderRadius: "8px",
      padding: "10px 20px",
      height: "auto",
    },
    label: {
      fontFamily: THEME_FONTS.heading,
      fontWeight: 600,
      fontSize: "14px",
    },
  };
};
